import React, { useState, useEffect } from 'react';
import { Container, TextField, Button, Table, AppBar, Toolbar, Box, CircularProgress, Typography, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal, Paper, Tooltip, InputAdornment } from '@mui/material';
import LoadingBar from 'react-top-loading-bar';
import { useNavigate } from 'react-router-dom';
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import SearchIcon from "@mui/icons-material/Search";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useParams } from "react-router-dom";
import base64 from "base64-js";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SectionMaster = () => {
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [canAdd, setCanAdd] = useState(null);
  const [canEdit, setCanEdit] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [sectionDetails, setSectionDetails] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  const [selectedSection, setSelectedSection] = useState({ sectionId: null, sectionName: '' });
  const [showModal, setShowModal] = useState(false);

  let navigate = useNavigate();

  const decodeFormId = (encodedFormId) => {
    if (!encodedFormId || typeof encodedFormId !== "string") {
      console.error("encodedFormId is missing or invalid:", encodedFormId);
      return null;
    }
    try {
      const paddedEncodedFormId = encodedFormId.padEnd(Math.ceil(encodedFormId.length / 4) * 4, "=");
      const bytes = base64.toByteArray(paddedEncodedFormId);
      return new TextDecoder().decode(bytes);
    } catch (error) {
      console.error("Error decoding formId:", error);
      return null;
    }
  };

  const { encodedFormId } = useParams();
  const formId = decodeFormId(encodedFormId);

  const Authorizer = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ formId, }), // replace with actual formId if hardcoded
      });

      const result = await response.json();
      const data = result[0];

      // setAuthorization(data);
      setCanEdit(data?.uModify === 1);
      setCanAdd(data?.uWrite === 1);
      setCanDelete(data?.uDelete === 1);
    } catch (error) {
      console.error("Authorization check failed:", error);
    }
  };


  const handleEdit = (sectionId) => {
    navigate(`/editsection/${sectionId}`)
  };

  const handleClick = () => {
    navigate('/addsection');
  };

  const handleDelete = async (sectionId) => {
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/Section/Id?SectionId=${sectionId}`;
      const token = sessionStorage.getItem('token'); // Make sure to have token logic in place

      setLoadingBarProgress(30);
      const response = await fetch(apiUrl, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      if (response.ok) {
        // Handle success, e.g., refresh the data
        setSectionDetails((prevDetails) => prevDetails.filter((section) => section.sectionId !== sectionId));
        setShowModal(false);
        setLoadingBarProgress(100);
        setSnackbarMessage('Section deleted successfully!');
        setOpenSnackbar(true);
      } else {
        setLoadingBarProgress(0);
        console.error('Delete failed');
        // alert('Failed to delete section');
        setSnackbarMessage('Failed to delete section');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    } catch (error) {
      console.error('API request error:', error);
      // alert('An error occurred. Please try again later.');
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  const handleClose = () => {
    setSelectedSection(null);
    setShowModal(false);
  };
  const handleShowModal = (section) => {
    setShowModal(true);
    setSelectedSection(section)

  }

  const fetchSectionData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Section/GetSection`, {
        method: "POST",
        headers: {
          "content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        setLoadingBarProgress(0);
        throw new Error(`Error fetching section data: ${response.status}`);
      }

      const data = await response.json();

      if (data.data === null && data.msg === "Record Not Found") {
        setLoadingBarProgress(0);
        console.error('Record Not Found');
        // alert('Record Not Found');
        setSnackbarMessage('Record Not Found');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
        return; // Exit the function if the record is not found
      }

      setLoadingBarProgress(100);
      setSectionDetails(data);
    } catch (error) {
      setLoadingBarProgress(0);
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  useEffect(() => {
    const filtered = sectionDetails.filter((section) =>
      section.sectionName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredData(filtered);
  }, [sectionDetails, searchTerm]);


  useEffect(() => {
    fetchSectionData();
    Authorizer();
    console.log(sectionDetails)
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1); // reset to page 1
  };



  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );


  return (
    <Container>
      <LoadingBar progress={loadingBarProgress} color="rgb(152, 106, 182)" height={5} />
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Section Details
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>

        <div className="mb-3" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px', gap: '0.5rem' }}>
          <TextField
            variant="outlined"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: "300px" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">

                  <SearchIcon />
                </InputAdornment>
              ),
              style: { padding: '0px 8px' },
            }}
            sx={{
              width: 300,
              backgroundColor: '#f9f9f9',
            }}
          />
          <Tooltip title={canAdd ? "Add Section" : "You are not Authorized to Add"} arrow>
            <span> <Button
              variant="contained"
              color="primary"
              className="my-2"
              onClick={handleClick}
              style={{
                width: "160px",
                height: "50px",
                padding: "10px 0",
                fontWeight: 'bold'
              }}
              disabled={!canAdd}
            >
              <b>ADD</b>
            </Button></span></Tooltip>
        </div>


        <TableContainer component={Paper}>
          <Table
            sx={{
              minWidth: 650,
              border: '1px solid #ccc',
              '& .MuiTableCell-root': {
                borderRight: '1px solid #ccc', // vertical line
                fontSize: '1rem', // increased font size
              },
              '& .MuiTableHead-root .MuiTableCell-root': {
                fontWeight: 'bold',
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell><strong>Section</strong></TableCell>
                <TableCell style={{ textAlign: 'center' }}><strong>Action</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sectionDetails.length === 0 && !loadingBarProgress ? (
                <TableRow>
                  <TableCell colSpan={2} align="center">
                    No Sections Found
                  </TableCell>
                </TableRow>
              ) : loadingBarProgress > 0 && loadingBarProgress < 100 ? (
                <TableRow>
                  <TableCell colSpan={2} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : paginatedData.length > 0 ? (
                paginatedData.map((section) => (
                  <TableRow key={section.sectionId}>
                    <TableCell>{section.sectionName}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>
                      <Tooltip title={canEdit ? "Edit Section" : "You are not Authorized to Edit"} arrow>
                        <span>
                          <Button
                            variant="contained"
                            color="warning"
                            style={{ marginLeft: '10px' }}
                            onClick={() => handleEdit(section.sectionId)}
                            startIcon={<EditIcon />}
                            disabled={!canEdit}
                          >
                            EDIT
                          </Button>
                        </span>
                      </Tooltip>
                      <Tooltip title={canDelete ? "Delete Section" : "You are not Authorized to Delete"} arrow>
                        <span>
                          <Button
                            className='mx-2'
                            variant="contained"
                            color="error"
                            onClick={() => handleShowModal(section)}
                            startIcon={<DeleteIcon />}
                            disabled={!canDelete}
                          >
                            DELETE
                          </Button>
                        </span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={2} align="center">
                    No Sections Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>

          </Table>

        </TableContainer>

        {filteredData.length > 0 && (
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
            <TextField
              select
              label="Rows per page"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              sx={{ width: 150 }}
              SelectProps={{
                native: true,
              }}
            >
              {rowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </TextField>
            <Box>
              <Typography variant="body2" sx={{ display: 'inline-block', marginRight: 2 }}>
                Page {page} of {Math.ceil(filteredData.length / rowsPerPage)}
              </Typography>
              <Button
                variant="outlined"
                onClick={() => handleChangePage(null, page - 1)}
                disabled={page === 1}
                sx={{ mr: 1 }}
              >
                Prev
              </Button>
              <Button
                variant="outlined"
                onClick={() => handleChangePage(null, page + 1)}
                disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              >
                Next
              </Button>
            </Box>
          </Box>
        )}


        {/* Delete Confirmation Modal */}
        <Modal open={showModal} onClose={handleClose} aria-labelledby="delete-modal-title" aria-describedby="delete-modal-description">
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: 'background.paper',
              borderRadius: 2,
              boxShadow: 24,
              overflow: 'hidden',
            }}
          >
            {/* Header */}
            <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
              <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
                Delete Confirmation ⚠️
              </Typography>
            </Box>

            {/* Content */}
            <Box sx={{ padding: '20px' }}>
              <Typography id="delete-modal-description" sx={{ mb: 2 }}>
                Are you sure you want to delete <strong>{selectedSection?.sectionName}</strong>?
              </Typography>

              {/* Buttons */}
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                <Button onClick={handleClose} variant="outlined" sx={{ mr: 1 }}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => handleDelete(selectedSection.sectionId)}
                >
                  Yes, Delete
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>
      </Paper>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>



    </Container>
  );
};

export default SectionMaster;

